// extracted by mini-css-extract-plugin
export default {"appContainer":"testPagePayment_appContainer__vFWXY"};